export function capitalize(str) {
    return `${str[0].toUpperCase()}${str.substr(1, str.length - 1)}`
}